module.exports = __webpack_public_path__ + "img/5.ca3a8f50.jpg";